import styled from '@emotion/styled'
import { Button } from '@chakra-ui/react'
import img from '../../assets/chronicle-bg.jpg'

export const ChronicleFixInfoWrapper = styled.div`
    background: linear-gradient(rgba(30, 37, 43, 0.3), rgba(30, 37, 43, 0.3)), url(${img}) no-repeat center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    color: white;
    min-height: 50vh;
    height: 100%;
    display: flex;
    justify-content: center;
    min-width: 300px;
    align-items: center;
    display: flex;
    flex-direction: column;
`

export const AdTitle = styled.div`
    text-align: center;
    font-size: 32px;
    font-weight: 500;
    margin-bottom: 0.5em;
    background: -webkit-linear-gradient(#00aff0, #92caf2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
`

export const InfoBtn = styled(Button)`
    font-weight: 500;
    margin-left: 0;
`
